var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.img)?_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.img,"alt":_vm.title}}):_vm._e(),_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default")],2),_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }